import { render, staticRenderFns } from "./StudentMondayComments.vue?vue&type=template&id=3a17a667&scoped=true&"
import script from "./StudentMondayComments.vue?vue&type=script&lang=js&"
export * from "./StudentMondayComments.vue?vue&type=script&lang=js&"
import style0 from "./StudentMondayComments.vue?vue&type=style&index=0&id=3a17a667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17a667",
  null
  
)

export default component.exports